export default {"src":"/_next/static/media/calendar-outline-white.2dbdd3b1.svg","height":31,"width":30,"blurWidth":0,"blurHeight":0};